
































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import {
  ConversationDto,
  MessageDto,
  MessageType,
  TrackableMessageDto
} from "@/types/interface/IM/IMTypes";
import { toLocalTime } from "@/api/net/util";
import Badge from "@/components/Badge.vue";

type ContentClass = {
  text: boolean;
  photo: boolean;
  brokenPhoto: boolean;
};

type SendStatus = {
  sendingMessage: boolean;
  sendingError: boolean;
};

@Component({
  name: "message-row",
  components: {}
})
export default class MessageRow extends Vue {
  public messageType = MessageType;

  public isTextContent(item: TrackableMessageDto) {
    return item.type === MessageType.Text;
  }

  @Prop() item: TrackableMessageDto;
  @Prop() owned: boolean;

  showPicture: string = "";
  photoFlag = false;
  photoCenter = false;
  showPhoto(val: string) {
    this.photoCenter = false;
    this.showPicture = val;
    this.photoFlag = true;
    let windowWidth = window.screen.width;

    let img = new Image();
    try {
      img.src = val;
      let height = img.height;
      if (height < windowWidth) {
        this.photoCenter = true;
      }
    } catch (error) {
      return;
    }
  }

  showId = false;
  showMessageById() {
    if (!this.owned) {
      this.showId = true;
    }
  }

  closePhoto() {
    this.photoFlag = false;
    this.showPicture = "";
  }

  get listItemClass(): string {
    return this.owned
      ? "content-warpper content-warpper-owned"
      : "content-warpper";
  }

  get listItemAvatarClass(): string {
    return this.owned ? "logo-wrapper logo-wrapper-owned" : "logo-wrapper";
  }

  get contentClass(): string {
    return this.owned && this.isTextContent(this.item)
      ? "content content-owned"
      : "content";
  }

  get getContent(): ContentClass {
    let contentType: ContentClass = {
      text: false,
      photo: false,
      brokenPhoto: false
    };
    if (this.item.type === this.messageType.Text) {
      contentType["text"] = true;
    } else if (
      this.item.type === this.messageType.Photo &&
      this.item.attachmentId
    ) {
      contentType["photo"] = true;
    } else if (
      this.item.type === this.messageType.Photo &&
      !this.item.attachmentId
    ) {
      contentType["brokenPhoto"] = true;
    }
    return contentType;
  }

  get sendMessage(): SendStatus {
    let loadingStatus: SendStatus = {
      sendingMessage: false,
      sendingError: false
    };
    if (this.item.isLoading && !this.item.hasError) {
      loadingStatus["sendingMessage"] = true;
    } else if (this.item.hasError) {
      loadingStatus["sendingError"] = true;
    }
    return loadingStatus;
  }
}
